import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import { isRequired } from '../../../core/validations';
import NotificationService from '../../../core/services/NotificationService';

class UnitRatingListService {
  fetch = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      units: [],
    });
    this.form.validations = {
      course: [isRequired],
      from: [isRequired],
      to: [isRequired],
    };
  }

  init = action(() => {
    this.units = [];
    this.form.setInitialValues({});
    this.form.reset();
  });

  load = action(() => {
    this.form.setSubmitted();
    if (this.form.errors) {
      NotificationService.addNotification('Please inform all filters', 'error');
      return;
    }
    this.fetch
      .fetch({
        apiVersion: 'v2',
        url: `/reports/unit-ratings`,
        query: {
          ...this.form.getValues(),
          from: this.form.getValue('from').startOf('day').toDate(),
          to: this.form.getValue('to').endOf('day').toDate(),
        },
      })
      .then(() => {
        if (this.fetch.data) {
          this.units = this.fetch.data;
        } else {
          this.units = [];
        }
      });
  });
}

const unitRatingListService = new UnitRatingListService();

export default unitRatingListService;
